import { createGtm } from "@gtm-support/vue-gtm";

export default defineNuxtPlugin((nuxtApp) => {
  const { gtmId } = useRuntimeConfig().public;

  const gtm = createGtm({
    id: gtmId,
    enabled: true,
    loadScript: true,
    defer: true,
  });

  // Use plugin
  nuxtApp.vueApp.use(gtm);
});
